import { toast } from 'sonner';

/**
 * 스낵바 — 모든 종류가 같은 모양(어두운 막대 · 아이콘 없음)이다 (Figma M-21 365:120).
 * 종류는 노출 시간만 다르다. 모양은 App.tsx Toaster의 toastOptions에서 정한다.
 * 모듈 싱글톤 — 훅 의존성에 넣어도 재생성되지 않게 한다 (admin과 같은 형태)
 */
export const toastApi = {
  success: (content: string, duration = 3) =>
    toast(content, { duration: duration * 1000 }),
  error: (content: string, duration = 5) =>
    toast(content, { duration: duration * 1000 }),
  info: (content: string, duration = 3) =>
    toast(content, { duration: duration * 1000 }),
};

/** X8 — 네트워크 오류 공통 문구. 로그인 외 모든 화면에서 같은 문구를 쓴다 */
export const showNetworkErrorToast = () =>
  // 같은 id로 띄워 여러 요청이 한꺼번에 실패해도 스낵바는 하나만 보인다
  toast('연결이 불안정해요', {
    id: 'network-error',
    description: '잠시 후 다시 시도해주세요.',
    duration: 3000,
  });
